import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Check } from "lucide-react";
import Orb from "@/components/Orb";

const BillingSuccess = () => {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState({ msg: "Verifying payment…", paid: false });

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { nav("/pricing"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${sid}`);
        if (data.payment_status === "paid") {
          try { await api.get("/billing/subscription", { params: { force: true } }); } catch { /* ignore */ }
          await refresh();
          setState({ msg: `Welcome to ${data.plan.toUpperCase()}`, paid: true });
          setTimeout(() => nav("/dashboard"), 1800);
          return;
        }
        if (data.status === "expired") { setState({ msg: "Session expired.", paid: false }); return; }
      } catch (_e) { /* ignore */ }
      if (++attempts < 8) setTimeout(poll, 2000);
      else setState({ msg: "Still processing. Check your dashboard later.", paid: false });
    };
    poll();
  }, []);

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-black">
      <div className="holo-mesh opacity-80" aria-hidden />
      <div className="relative z-10 flex flex-col items-center max-w-md w-full mx-6 text-center">
        {state.paid ? (
          <>
            <Orb size={220} active />
            <div className="mt-6 w-12 h-12 bg-white text-black flex items-center justify-center rounded-full glow-amber">
              <Check size={22}/>
            </div>
          </>
        ) : (
          <Loader2 className="animate-spin text-white" size={40}/>
        )}
        <div className="label-mono mt-8 mb-3">{state.paid ? "/ activated" : "/ verifying"}</div>
        <h1 className="font-display text-3xl tightest font-semibold leading-tight">{state.msg}</h1>
        {state.paid && <p className="text-neutral-500 text-[0.86rem] mt-3">Redirecting you to the dashboard…</p>}
      </div>
    </div>
  );
};

export default BillingSuccess;
